import { render } from "./reservas.vue?vue&type=template&id=2ff9db1d&scoped=true"
import script from "./reservas.vue?vue&type=script&lang=js"
export * from "./reservas.vue?vue&type=script&lang=js"

import "./reservas.vue?vue&type=style&index=0&id=2ff9db1d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ff9db1d"]])

export default __exports__